document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("quickProductModal");
  const closeBtn = modal.querySelector(".close");
  const addToCartBtn = document.getElementById("addToCartBtn");
  let currentProduct = null;

  closeBtn.addEventListener("click", function () {
    closeModal();
  });

  window.addEventListener("click", function (event) {
    if (event.target === modal) closeModal();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.style.display === "block") closeModal();
  });

  function openModal() {
    modal.style.display = "block";
    setTimeout(() => {
      modal.classList.add("active");
    }, 10);
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.classList.remove("active");
    setTimeout(() => {
      modal.style.display = "none";
    }, 300);
    document.body.style.overflow = "";
    currentProduct = null;
  }

  const quantityInput = document.getElementById("quantity");
  const quantityBtns = document.querySelectorAll(".quantity-btn");

  quantityBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const currentValue = parseInt(quantityInput.value);
      if (this.dataset.action === "increase")
        quantityInput.value = currentValue + 1;
      else if (this.dataset.action === "decrease" && currentValue > 1)
        quantityInput.value = currentValue - 1;
    });
  });

  function fetchProductInfo(productHandle) {
    fetch(`/products/${productHandle}.json`)
      .then((response) => response.json())
      .then((data) => {
        currentProduct = data.product;
        populateProductModal(currentProduct);
        openModal();
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  }

  function findVariantByOptions(product, selectedOptions) {
    product.variants.forEach((variant, index) => {
      const variantOptions = [
        variant.option1,
        variant.option2,
        variant.option3,
      ].filter(Boolean);
    });

    return product.variants.find((variant) => {
      const variantOptions = [
        variant.option1,
        variant.option2,
        variant.option3,
      ].filter(Boolean);

      // Si las longitudes no coinciden, verificar si las opciones seleccionadas están contenidas
      if (selectedOptions.length !== variantOptions.length) {
        // Verificar si todas las opciones seleccionadas están en la variante
        for (let i = 0; i < selectedOptions.length; i++) {
          if (!variantOptions.includes(selectedOptions[i])) return false;
        }
        return true;
      } else {
        // Comparación exacta por posición
        for (let i = 0; i < selectedOptions.length; i++) {
          if (variantOptions[i] !== selectedOptions[i]) {
            return false;
          }
        }
        return true;
      }
    });
  }

  function updatePriceForVariant() {
    if (!currentProduct) return;

    const selectedOptions = [];
    document
      .querySelectorAll("#variantOptions .variant-select")
      .forEach((select) => {
        selectedOptions.push(select.value);
      });

    const variant = findVariantByOptions(currentProduct, selectedOptions);

    if (variant) {
      const price =
        variant.compare_at_price && parseFloat(variant.compare_at_price) > 0
          ? formatMoney(variant.compare_at_price)
          : formatMoney(variant.price);

      const salePrice =
        variant.compare_at_price && parseFloat(variant.compare_at_price) > 0
          ? formatMoney(variant.price)
          : null;

      document.getElementById("productPrice").textContent = price;

      const salePriceElement = document.getElementById("productPriceSale");
      if (salePriceElement) {
        salePriceElement.textContent = salePrice;

        if (salePrice) {
          salePriceElement.style.display = "inline-block";
          document
            .getElementById("productPrice")
            .classList.add("product-price-original");
        } else {
          salePriceElement.style.display = "none";
          document
            .getElementById("productPrice")
            .classList.remove("product-price-original");
        }
      }

      if (addToCartBtn.dataset) {
        addToCartBtn.dataset.variantId = variant.id;
      }

      // También actualizar el botón clonado si existe
      const clonedBtn = document.getElementById("addToCartBtn");
      if (clonedBtn && clonedBtn.dataset) {
        clonedBtn.dataset.variantId = variant.id;
      }

      if (variant.available === false) {
        const currentBtn = document.getElementById("addToCartBtn");
        currentBtn.textContent = "Agotado";
        currentBtn.disabled = true;
        currentBtn.classList.add("disabled");
      } else {
        const currentBtn = document.getElementById("addToCartBtn");
        currentBtn.textContent = "Añadir a la cesta";
        currentBtn.disabled = false;
        currentBtn.classList.remove("disabled");
      }
    }
  }

  function populateProductModal(product) {
    const price =
      product.variants[0].compare_at_price &&
      parseFloat(product.variants[0].compare_at_price) > 0
        ? formatMoney(product.variants[0].compare_at_price)
        : formatMoney(product.variants[0].price);
    const salePrice =
      product.variants[0].compare_at_price &&
      parseFloat(product.variants[0].compare_at_price) > 0
        ? formatMoney(product.variants[0].price)
        : null;

    document.getElementById("productTitle").textContent = product.title;
    document.getElementById("productPrice").textContent = price;

    const salePriceElement = document.getElementById("productPriceSale");
    if (salePriceElement) {
      salePriceElement.textContent = salePrice;

      if (salePrice) {
        salePriceElement.style.display = "inline-block";
        document
          .getElementById("productPrice")
          .classList.add("product-price-original");
      } else {
        salePriceElement.style.display = "none";
        document
          .getElementById("productPrice")
          .classList.remove("product-price-original");
      }
    }

    document.getElementById("productDescription").innerHTML =
      product.description || "";
    document.getElementById(
      "viewDetailsLink"
    ).href = `/products/${product.handle}`;

    const mainImage = document.getElementById("productMainImage");
    if (product.images && product.images.length > 0) {
      mainImage.src = product.images[0].src;
      mainImage.alt = product.title;
    }

    const variantOptions = document.getElementById("variantOptions");
    variantOptions.innerHTML = "";

    if (product.options && product.options.length > 0) {
      product.options.forEach((option, optionIndex) => {
        if (option.values.length <= 1) return;

        const variantGroup = document.createElement("div");
        variantGroup.className = "variant-group";

        const label = document.createElement("label");
        label.className = "variant-label";
        label.textContent = option.name + ":";
        label.htmlFor = `option-${option.name}`;

        const select = document.createElement("select");
        select.className = "variant-select";
        select.id = `option-${option.name}`;
        select.name = option.name;
        select.dataset.optionIndex = optionIndex;

        option.values.forEach((value) => {
          const optionEl = document.createElement("option");
          optionEl.value = value;
          optionEl.textContent = value;
          select.appendChild(optionEl);
        });

        select.addEventListener("change", updatePriceForVariant);

        variantGroup.appendChild(label);
        variantGroup.appendChild(select);
        variantOptions.appendChild(variantGroup);
      });
    }

    setupAddToCartButton(product);
  }

  function formatMoney(price) {
    return parseFloat(price).toFixed(2).replace(".", ",") + "€";
  }

  function setupAddToCartButton(product) {
    addToCartBtn.replaceWith(addToCartBtn.cloneNode(true));
    const newAddToCartBtn = document.getElementById("addToCartBtn");

    // Inicializar con la primera variante
    newAddToCartBtn.dataset.variantId = product.variants[0].id;

    newAddToCartBtn.addEventListener("click", function () {
      const quantity = parseInt(document.getElementById("quantity").value);
      let variantId =
        newAddToCartBtn.dataset.variantId || product.variants[0].id;

      // Si hay múltiples variantes y no tenemos un variantId guardado, calcularlo
      if (product.variants.length > 1 && !newAddToCartBtn.dataset.variantId) {
        const selectedOptions = [];
        document.querySelectorAll(".variant-select").forEach((select) => {
          selectedOptions.push(select.value);
        });

        const variant = findVariantByOptions(product, selectedOptions);
        if (variant) {
          variantId = variant.id;
        }
      }

      addToCart(variantId, quantity);
    });
  }

  function addToCart(variantId, quantity) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        closeModal();
        updateCartCount();
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Actualizar el contador específico del header
        const cartCountElement = document.querySelector(
          "#CartCount span:first-child"
        );
        if (cartCountElement) {
          cartCountElement.textContent = cart.item_count;
          console.log("Contador del header actualizado");
        }

        // También actualizar cualquier otro contador que pueda existir
        const cartCountElements = document.querySelectorAll(".cart-count");
        if (cartCountElements.length) {
          cartCountElements.forEach((el) => {
            el.textContent = cart.item_count;
          });
        }
      })
      .catch((error) => {
        console.error("Error al actualizar contador del carrito:", error);
      });
  }

  window.openProductModal = function (productHandle) {
    fetchProductInfo(productHandle);
  };

  window.fetchProductInfo = fetchProductInfo;
});
